<template>
  <div class="component-container card-overflow">
    <v-card
      class="component-container component-overflow card-login"
      :class="{ 'hidden-card': !hiddenLoginCard }"
    >
      <v-form
        ref="formLogin"
        v-model="formValid"
        @submit.prevent="handleLogin"
        class="h-100 d-flex flex-column"
      >
        <v-container class="logo-container">
          <img alt="logo Boomerang" class="logo" src="@/assets/images/boomerang_black_logo.png" />
        </v-container>

        <v-spacer />

        <v-container>
          <h1 class="title">{{ $t('LOGIN_PAGE.TITLE.HEADER') }}</h1>
          <p class="subtitle">{{ $t('LOGIN_PAGE.TITLE.EMAIL') }}</p>
          <v-text-field v-model="email" :rules="[...requiredRules, ...emailRules]" />
          <p class="subtitle">{{ $t('LOGIN_PAGE.TITLE.PASSWORD') }}</p>
          <v-text-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            :rules="[...requiredRules, ...passwordRules]"
            :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append-inner="togglePasswordVisibility"
          >
          </v-text-field>
          <div class="forget-password">
            <router-link to="/forgot-password" class="link">
              {{ $t('LOGIN_PAGE.BUTTON.FORGOT_PASSWORD') }}
            </router-link>
          </div>
        </v-container>

        <v-spacer />

        <v-container class="bottom-container">
          <v-btn
            class="boom-button"
            type="submit"
            variant="outlined"
            :loading="loading"
            :disabled="loading || !formValid"
          >
            {{ $t('LOGIN_PAGE.BUTTON.SUBMIT') }}
          </v-btn>
          <div class="d-flex justify-space-between pt-4">
            <section class="image-container">
              <a class="link" :href="'mailto:' + mailBoomerang">
                <img alt="Vue logo" class="icon-images" src="@/assets/icons/login/tools.png" />
                {{ $t('LOGIN_PAGE.BUTTON.HELP') }}
              </a>
            </section>
            <section class="image-container">
              <router-link to="/register" class="link">
                <img
                  alt="Vue logo"
                  class="icon-images"
                  src="@/assets/icons/login/crossRounded.png"
                />
                {{ $t('LOGIN_PAGE.BUTTON.ADD_ACCOUNT') }}
              </router-link>
            </section>
          </div>
        </v-container>
      </v-form>
    </v-card>

    <SelectCollaboratorPage
      v-if="loadCollaboratorComponent"
      class="login-container card-collaborator"
      :class="{ 'hidden-card-collaborator': showCollaboratorComponent }"
      @messageFromChild="handleMessage"
    />
  </div>
</template>

<script>
import Validator from '/src/components/utils/validator'
import localPermissions from '@/constants/localPermissions'
import router from '@/router'
import SelectCollaboratorPage from '@/views/login/restricted/collaborator/SelectCollaboratorPage.vue'
import { displayToast } from '@/components/utils/globalFunction'
import { mapState } from 'vuex'

export default {
  name: 'LoginPage',
  components: { SelectCollaboratorPage },
  data() {
    const mailBoomerang = import.meta.env.VITE_MAIL_BOOMERANG
    return {
      mailBoomerang,
      isLogout: null,
      loading: false,
      email: '',
      password: '',
      showPassword: false,
      hiddenLoginCard: true,
      loadCollaboratorComponent: false,
      showCollaboratorComponent: false,
      formValid: false,
      requiredRules: Validator.requiredRules,
      passwordRules: Validator.passwordRules,
      emailRules: Validator.emailRules
    }
  },
  computed: {
    ...mapState({
      collaborator: 'collaborator'
    })
  },
  methods: {
    async handleLogin() {
      this.loading = true

      const userData = {
        email: this.email,
        password: this.password
      }
      try {
        await this.$store.dispatch('auth/login', userData)

        const connectedUserPermissionList = this.$store.state.auth.userDetail.permissionList
        const connectedUserCollaboratorList = this.$store.state.auth.userDetail.collaboratorList
        const connectedUserHasSeveralCollaborators =
          this.$store.state.auth.userDetail.hasSeveralCollaborators
        //check if only one collaborator and can't add new
        if (
          (!connectedUserPermissionList.some(
            (perm) => perm.title === localPermissions.DISTRIBUTOR_ADD_COLLABORATOR.title
          ) &&
            connectedUserCollaboratorList.length === 1) ||
          (!connectedUserHasSeveralCollaborators && connectedUserCollaboratorList.length === 1)
        ) {
          await this.loginToDashboard()
        }
        this.loadCollaboratorComponent = true
        setTimeout(() => {
          this.showCollaboratorComponent = true
        }, 100)
        setTimeout(() => {
          this.hiddenLoginCard = false
        }, 100)
        displayToast(this.$t('LOGIN_PAGE.MESSAGE.SUCCESS'), 'success')
      } catch (error) {
        displayToast(this.$t('LOGIN_PAGE.MESSAGE.ERROR'), 'error')
      } finally {
        this.loading = false
      }
    },

    async loginToDashboard() {
      const connectedUserCollaborator = this.$store.state.auth.userDetail.collaboratorList[0]
      this.$store.commit('auth/selectedCollaborator', connectedUserCollaborator.technical_id)
      await router.push({ path: '/dashboard' })
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    handleMessage(message) {
      if (message === 'logout') {
        this.loadCollaboratorComponent = false
        this.hiddenLoginCard = true
        setTimeout(() => {
          this.showCollaboratorComponent = false
        }, 100)
        setTimeout(() => {
          this.hiddenLoginCard = true
        }, 100)
      }
    }
  }
}
</script>
<style scoped>
.icon-images {
  height: 20px;
  margin-right: 5px;
}

.card-overflow {
  overflow: hidden;
  position: relative;
  background-color: transparent !important;
}

.card-login {
  z-index: 2;
  position: absolute;
}

.card-collaborator {
  left: 100%;
  position: absolute;
}

.hidden-card {
  transform: translateX(100%);
}

:deep(.v-field__append-inner .v-icon) {
  color: lightgrey !important;
}

.hidden-card-collaborator {
  left: 95%;
  transform: translateX(-100%);
}

:deep(.v-field) {
  overflow: hidden;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subtitle {
  line-height: 20px;
  text-align: left;
  margin-bottom: 2%;
}

.title {
  text-align: center;
  font-size: 150%;
  font-style: normal;
  padding-bottom: 10%;
}

.image-container {
  display: flex;
  align-items: center;
}

.link:hover {
  color: #559a1b;
}

.link {
  margin: unset;
}

.icon-images {
  height: 20px;
  margin-right: 5px;
}

.forget-password {
  margin: auto;
  display: flex;
  justify-content: end;
}

.boom-button {
  width: 100%;
}

.component-container {
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 5%;
  padding: 0 7%;
  transition: transform 0.3s;
}

.component-overflow {
  overflow-y: auto;
}

@media (max-width: 499px) {
  .component-container {
    width: 90vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 500px) and (max-width: 767px) {
  .component-container {
    width: 70vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 768px) and (max-width: 1099px) {
  .component-container {
    width: 40vw;
    height: 80vh;
  }
}

@media (min-width: 1100px) and (max-width: 1599px) {
  .component-container {
    width: 30vw;
    height: 80vh;
  }
}

@media (min-width: 1600px) {
  .component-container {
    width: 20vw;
    height: 80vh;
  }
}

:deep(.v-text-field .v-input__details) {
  padding-inline-start: unset;
  padding-inline-end: unset;
}

.logo-container {
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;
  padding: unset;
}

.logo {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  justify-content: center;
  width: 90%;
}

.bottom-container {
  padding-bottom: 36px;
}
</style>
